/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BillCreateRespVo
 */
export interface BillCreateRespVo {
    /**
     * 新创建账单的ID
     * @type {number}
     * @memberof BillCreateRespVo
     */
    billId?: number;
    /**
     * 代买取消分单后的新订单ID，仅billType=2且发生分单时有值，其他场景为null
     * @type {number}
     * @memberof BillCreateRespVo
     */
    splitPurchaseCancelID?: number;
}

/**
 * Check if a given object implements the BillCreateRespVo interface.
 */
export function instanceOfBillCreateRespVo(value: object): value is BillCreateRespVo {
    return true;
}

export function BillCreateRespVoFromJSON(json: any): BillCreateRespVo {
    return BillCreateRespVoFromJSONTyped(json, false);
}

export function BillCreateRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillCreateRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'billId': json['billId'] == null ? undefined : json['billId'],
        'splitPurchaseCancelID': json['splitPurchaseCancelID'] == null ? undefined : json['splitPurchaseCancelID'],
    };
}

export function BillCreateRespVoToJSON(json: any): BillCreateRespVo {
    return BillCreateRespVoToJSONTyped(json, false);
}

export function BillCreateRespVoToJSONTyped(value?: BillCreateRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'billId': value['billId'],
        'splitPurchaseCancelID': value['splitPurchaseCancelID'],
    };
}

